/*
  Animated halftone dot background (hero-banner "Animated art" mode).
  A staggered dot grid on a canvas; a slow diagonal wave swells and
  shrinks the dots. Runs at ~30fps and only while on screen.
  Markup: <canvas class="hero-dots" data-bg="#dc1c31" data-dot="#fa213e"
          data-spacing="2" data-wave="1"></canvas>
  data-spacing = distance between dots as % of the hero width
*/
(function () {
  if (window.__heroDotsLoaded) return;
  window.__heroDotsLoaded = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Dots(canvas) {
    this.c = canvas;
    this.ctx = canvas.getContext('2d');
    this.bg = canvas.dataset.bg || '#dc1c31';
    this.dot = canvas.dataset.dot || '#fa213e';
    this.spacingPct = parseFloat(canvas.dataset.spacing) || 2;
    this.wave = parseFloat(canvas.dataset.wave);
    if (isNaN(this.wave)) this.wave = 1;
    this.visible = false;
    this.last = 0;
    this.tick = this.tick.bind(this);
  }

  Dots.prototype.resize = function () {
    var w = this.c.clientWidth;
    var h = this.c.clientHeight;
    if (!w || !h) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    this.c.width = Math.round(w * dpr);
    this.c.height = Math.round(h * dpr);
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.w = w;
    this.h = h;
    // Keep dots a sensible size on phones and very wide screens
    this.s = Math.max(18, Math.min(40, (w * this.spacingPct) / 100));
    this.draw(performance.now());
  };

  Dots.prototype.draw = function (now) {
    var ctx = this.ctx;
    var s = this.s;
    var t = reduced ? 0 : now / 1000;
    if (this.bg === 'none') {
      ctx.clearRect(0, 0, this.w, this.h);
    } else {
      ctx.fillStyle = this.bg;
      ctx.fillRect(0, 0, this.w, this.h);
    }
    ctx.fillStyle = this.dot;
    var R = s * 0.31;
    var amp = 0.28 * this.wave;
    var k = (Math.PI * 2) / (s * 14); // wavelength = 14 dots
    ctx.beginPath();
    for (var row = 0, y = 0; y < this.h + s; row++, y += s / 2) {
      var x0 = row % 2 ? s / 2 : 0;
      for (var x = x0; x < this.w + s; x += s) {
        // Diagonal wave rolling down-left, plus a slow second swell
        var p = Math.sin((x * 0.8 + y) * k - t * 1.1) * 0.75 +
          Math.sin((x - y * 0.6) * k * 0.45 + t * 0.5) * 0.25;
        var r = R * (1 - amp * 0.5 + amp * 0.5 * (p + 1) * 0.9);
        ctx.moveTo(x + r, y);
        ctx.arc(x, y, r, 0, Math.PI * 2);
      }
    }
    ctx.fill();
  };

  Dots.prototype.tick = function (now) {
    if (!this.visible) return;
    if (!this.last || now - this.last >= 33) {
      this.last = now;
      this.draw(now);
    }
    requestAnimationFrame(this.tick);
  };

  // Stop for good (e.g. once a photo covers the dots)
  Dots.prototype.stop = function () {
    this.stopped = true;
    this.visible = false;
  };

  Dots.prototype.setVisible = function (v) {
    if (v === this.visible || reduced || !this.wave || this.stopped) return;
    this.visible = v;
    if (v) requestAnimationFrame(this.tick);
  };

  function init(c) {
    if (c.__dots) return;
    var d = (c.__dots = new Dots(c));
    d.resize();
    if ('ResizeObserver' in window) new ResizeObserver(function () { d.resize(); }).observe(c);
    else window.addEventListener('resize', function () { d.resize(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { d.setVisible(e.isIntersecting); });
      }).observe(c);
    } else {
      d.setVisible(true);
    }
  }

  function initAll() {
    document.querySelectorAll('canvas.hero-dots').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
